import { useEffect, useMemo } from 'react';

import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { LoaderScreen } from 'components/pages/LoaderScreen';
import { FadeAnimation } from 'components/templates/FadeWrapper';
import { useIsAuthenticated } from 'hooks/api/auth/useIsAuthenticated';

import { AdminLayoutWrapper } from './AdminLayout.styled';
import { Header } from './Header';

export const AdminLayout = (): JSX.Element => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const { authChecked, authenticated, loading } = useIsAuthenticated();

    const backPath = useMemo(
        () => (pathname !== '/admin/auth' ? pathname : undefined),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    useEffect(() => {
        if (authChecked && !authenticated) {
            navigate(`/admin/auth${backPath ? `?back=${backPath}` : ''}`, {
                replace: true,
            });
        }
    }, [authChecked, authenticated, navigate, pathname, backPath]);

    if (!authChecked || loading) {
        return (
            <FadeAnimation>
                <LoaderScreen />
            </FadeAnimation>
        );
    }

    if (pathname === '/admin') {
        return <Navigate to="/admin/content_manager" />;
    }

    return (
        <FadeAnimation key={`anim_${authenticated}`}>
            <AdminLayoutWrapper>
                {pathname !== '/admin/auth' ? <Header /> : undefined}
                <FadeAnimation key={pathname}>
                    <Outlet />
                </FadeAnimation>
            </AdminLayoutWrapper>
        </FadeAnimation>
    );
};
